import { render, staticRenderFns } from "./Projets.vue?vue&type=template&id=60ff2a0e&scoped=true&"
import script from "./Projets.vue?vue&type=script&lang=js&"
export * from "./Projets.vue?vue&type=script&lang=js&"
import style0 from "./Projets.vue?vue&type=style&index=0&id=60ff2a0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ff2a0e",
  null
  
)

export default component.exports